import { render, staticRenderFns } from "./DealersRoleDetail.vue?vue&type=template&id=9e320df2&scoped=true"
import script from "./DealersRoleDetail.vue?vue&type=script&lang=ts"
export * from "./DealersRoleDetail.vue?vue&type=script&lang=ts"
import style0 from "./DealersRoleDetail.vue?vue&type=style&index=0&id=9e320df2&lang=scss"
import style1 from "./DealersRoleDetail.vue?vue&type=style&index=1&id=9e320df2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e320df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e320df2')) {
      api.createRecord('9e320df2', component.options)
    } else {
      api.reload('9e320df2', component.options)
    }
    module.hot.accept("./DealersRoleDetail.vue?vue&type=template&id=9e320df2&scoped=true", function () {
      api.rerender('9e320df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-roles/components/DealersRoleDetail.vue"
export default component.exports